import * as React from 'react';
import CheckboxOutlined from './checkbox-outlined';
import CheckboxFilled from './checkbox-filled';
import type { IconCombinedProps } from './types';
const CheckboxCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <CheckboxFilled ref={ref} {...rest} />;
  }
  return <CheckboxOutlined ref={ref} {...rest} />;
});
export default CheckboxCombined;